import { render, staticRenderFns } from "./ModalOrderQuestions.vue?vue&type=template&id=476cad66"
import script from "./ModalOrderQuestions.vue?vue&type=script&lang=js"
export * from "./ModalOrderQuestions.vue?vue&type=script&lang=js"
import style0 from "./ModalOrderQuestions.vue?vue&type=style&index=0&id=476cad66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports